$(document).ready(function () {
    "use strict";

    // open menu on click
    $('.js_carzFlyoutButton').on('click', function (e) {
        e.preventDefault();

        var body = $('body');

        body.toggleClass('slideOut');
        body.toggleClass('noScroll');
    });

    // close menu on click (button within menu)
    $('.js_carzCloseMenu').on('click', function (e) {
        e.preventDefault();

        var body = $('body');

        body.removeClass('slideOut');
        body.removeClass('noScroll');
    });
});